import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export const DATASET_KEYS = {
  commercial: 'commercial',
  residential: 'residential'
} as const;

export type DatasetKey = (typeof DATASET_KEYS)[keyof typeof DATASET_KEYS];

const storageKey = 'mri-dsg:selected-dataset';
const defaultDatasetKey: DatasetKey = DATASET_KEYS.commercial;

function isDatasetKey(value: string | null): value is DatasetKey {
  return value === DATASET_KEYS.commercial || value === DATASET_KEYS.residential;
}

function readInitial(): DatasetKey {
  const stored = sessionStorage.getItem(storageKey);
  return isDatasetKey(stored) ? stored : defaultDatasetKey;
}

@Injectable({ providedIn: 'root' })
export class SelectedDatasetService {
  private readonly subject = new BehaviorSubject<DatasetKey>(readInitial());
  readonly selected$: Observable<DatasetKey> = this.subject.pipe(distinctUntilChanged());

  get current(): DatasetKey {
    return this.subject.value;
  }

  select(key: DatasetKey): void {
    if (key === this.subject.value) {
      return;
    }
    sessionStorage.setItem(storageKey, key);
    this.subject.next(key);
  }
}
